import {
  DeesElement,
  customElement,
  html,
  css,
  cssManager,
  property,
  type TemplateResult,
} from '@design.estate/dees-element';
import { dashboardCardStyles } from './sz-dashboard-card.styles.js';

declare global {
  interface HTMLElementTagNameMap {
    'sz-reverse-proxy-card': SzReverseProxyCard;
  }
}

@customElement('sz-reverse-proxy-card')
export class SzReverseProxyCard extends DeesElement {
  public static demo = () => html`
    <div style="padding: 24px; max-width: 400px;">
      <sz-reverse-proxy-card
        httpPort="8080"
        httpsPort="8443"
        httpActive
        httpsActive
        routeCount="3"
      ></sz-reverse-proxy-card>
    </div>
  `;

  public static demoGroups = ['Network'];

  @property({ type: String })
  public accessor httpPort: string = '80';

  @property({ type: String })
  public accessor httpsPort: string = '443';

  @property({ type: Boolean })
  public accessor httpActive: boolean = false;

  @property({ type: Boolean })
  public accessor httpsActive: boolean = false;

  @property({ type: String })
  public accessor routeCount: string = '0';

  public static styles = [
    cssManager.defaultStyles,
    dashboardCardStyles,
    css`
      .items {
        display: flex;
        flex-direction: column;
        gap: var(--dees-spacing-md);
      }

      .item {
        min-height: 28px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: var(--dees-spacing-md);
      }

      .item-label {
        min-width: 0;
        color: var(--dees-color-text-secondary);
        font-size: var(--dees-font-callout-size);
      }

      .item-value {
        color: var(--dees-color-text-primary);
        font-family: var(--dees-font-family-mono);
        font-size: var(--dees-font-callout-size);
      }
    `,
  ];

  public render(): TemplateResult {
    return html`
      <dees-tile>
        <div slot="header" class="card-header">
          <div class="header-copy">
            <div class="card-title">Reverse Proxy</div>
            <div class="card-subtitle">HTTP and HTTPS ingress</div>
          </div>
          <dees-icon icon="lucide:Router" .iconSize=${18}></dees-icon>
        </div>

        <div class="card-content">
          <div class="items">
            <div class="item">
              <span class="item-label">HTTP · ${this.httpPort}</span>
              <dees-badge
                rounded
                .type=${this.httpActive ? 'success' : 'error'}
                .text=${this.httpActive ? 'Active' : 'Inactive'}
              ></dees-badge>
            </div>
            <div class="item">
              <span class="item-label">HTTPS · ${this.httpsPort}</span>
              <dees-badge
                rounded
                .type=${this.httpsActive ? 'success' : 'error'}
                .text=${this.httpsActive ? 'Active' : 'Inactive'}
              ></dees-badge>
            </div>
            <div class="item">
              <span class="item-label">Routes</span>
              <span class="item-value">${this.routeCount}</span>
            </div>
          </div>
        </div>
      </dees-tile>
    `;
  }
}
